var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, untracked, makeObservable } from 'mobx';
import { computedFn } from 'mobx-utils';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
import { FunnelType } from '../../../learnware/LearnwareEnums';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class FunnelIncoming {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get funnel() {
        return this.parent;
    }
    get app() {
        return this.funnel.app;
    }
    get allMiniQuestions() {
        return this.app.topic.topicMiniQuestions.miniQuestions;
    }
    get miniQuestionsFiltered() {
        console.log('recalculate minis in Order');
        if (this.app.topic.funnel === FunnelType.Succession) {
            return this.funnel.funnelOrderSuccession.successionFilter.filteredSuccessionMiniQuestions;
        }
        return this.funnel.funnelMixed.mixedFilter.filteredMixedMiniQuestions;
    }
    get miniQuestionsSorted() {
        console.log('recalculate minis in Order');
        if (this.app.topic.funnel === FunnelType.Succession) {
            return this.funnel.funnelOrderSuccession.miniQuestionsSuccessionSorted;
        }
        return this.funnel.funnelMixed.miniQuestionsMixedSorted;
    }
    get isFunnelReady() {
        if (!this.app.appBoot.isInteractive ||
            !this.app.topic.topicMicroQuestions.microQuestionsQuery.triggeredIsAvailable ||
            !this.app.history.historyDbMicroAnswers.microAnswersQuery.triggeredIsAvailable ||
            !this.app.topic.topicFilter.filterQuestionQuery.triggeredIsAvailable) {
            return false;
        }
        return true;
    }
    get remainingAnswersSorted() {
        if (!this.isFunnelReady) {
            return [];
        }
        // const { posedAnswerNotCompleted } = this.app.pose.poseAnswer;
        const minis = untracked(() => this.miniQuestionsSorted);
        const refreshOnRecalculate = this.funnel.funnelManualRefresher; // eg. skip, complete question, filter, ...
        const refreshOnChangedAnswer = this.app.answer;
        return minis.map(miniQuestion => miniQuestion.toFunnelAnswer);
    }
    get numberOfIncomingAnswers() {
        return this.miniQuestionsFiltered.length;
    }
    get funnelIncomingAnswers() {
        return this.remainingAnswersSorted;
    }
    get allMiniQuestionsBelowLevel() {
        return computedFn((level) => this.allMiniQuestions.filter(mini => mini.micro.level < level));
    }
}
__decorate([
    computed
], FunnelIncoming.prototype, "miniQuestionsFiltered", null);
__decorate([
    computed
], FunnelIncoming.prototype, "miniQuestionsSorted", null);
__decorate([
    sortedSet
], FunnelIncoming.prototype, "remainingAnswersSorted", null);
__decorate([
    computed
], FunnelIncoming.prototype, "numberOfIncomingAnswers", null);
__decorate([
    memoize
], FunnelIncoming.prototype, "allMiniQuestionsBelowLevel", null);
